import { Routes, RouterModule } from "@angular/router";
import {ReadingComponent} from "./reading.component";

const readingRoutes: Routes = [
    {path: "reading/:selectionName", component: ReadingComponent}
];

export const readingRouting = RouterModule.forChild(readingRoutes);
